import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { useAPI } from '../contexts/APIContext';
import { MdButton, MdIconButtonSimple } from './MaterialComponents';

const Navigation = ({ currentPage, onPageChange }) => {
  const { t, toggleLanguage } = useTranslation();
  const { apiStatus } = useAPI();
  
  return (
    <nav className="navigation">
      <div className="navigation-content">
        <div className="nav-logo">
          <img src="/ico.png" alt={t('appTitle')} />
          <h1>{t('appTitle')}</h1>
        </div>
        
        <div className="nav-buttons">
          <MdButton 
            variant={currentPage === 'chat' ? 'filled' : 'text'}
            onClick={() => onPageChange('chat')}
            icon={currentPage === 'chat' ? 'chat' : null}
          >
            {t('chat')}
          </MdButton>
          
          <MdButton 
            variant={currentPage === 'help' ? 'filled' : 'text'}
            onClick={() => onPageChange('help')}
            icon={currentPage === 'help' ? 'help' : null}
          >
            {t('help')}
          </MdButton>
          
          <MdButton 
            variant={currentPage === 'settings' ? 'filled' : 'text'}
            onClick={() => onPageChange('settings')}
            icon={currentPage === 'settings' ? 'settings' : null}
          >
            {t('settings')}
          </MdButton>
          
          <MdIconButtonSimple
            icon="language"
            onClick={toggleLanguage}
            title="切换语言 / Switch Language"
            style={{ marginLeft: '8px' }}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navigation;